<template>
  <component
    :is="clickUrl ? 'a' : 'div'"
    class="player-logo"
    :class="[positionClass, { 'player-logo--hidden': !visible }]"
    :href="clickUrl || undefined"
    :target="clickUrl ? '_blank' : undefined"
    :rel="clickUrl ? 'noopener noreferrer' : undefined"
  >
    <img
      :src="logoUrl"
      alt=""
      class="player-logo__img"
    />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  logoUrl: string
  position?: 'top_left' | 'top_right' | 'bottom_left' | 'bottom_right'
  clickUrl?: string
  visible?: boolean
}>(), {
  visible: true,
})

const positionClass = computed(() => {
  const pos = props.position ?? 'top_right'
  return `player-logo--${pos}`
})
</script>

<style lang="scss" scoped>
.player-logo {
  position: absolute;
  z-index: 10;
  pointer-events: auto;
  padding: 12px;
  transition: opacity 0.3s ease;

  &--hidden {
    opacity: 0;
    pointer-events: none;
  }

  &--top_left {
    top: 0;
    left: 0;
  }

  &--top_right {
    top: 0;
    right: 0;
  }

  &--bottom_left {
    bottom: 80px;
    left: 0;
  }

  &--bottom_right {
    bottom: 80px;
    right: 0;
  }

  &__img {
    max-height: 40px;
    max-width: 120px;
    object-fit: contain;
  }
}

a.player-logo:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: 2px;
  border-radius: 4px;
}
</style>
